module.exports = __webpack_public_path__ + "static/source-sans-pro-v13-latin-ext_latin-regular-054403219b0b4b43a21d9dddd8e6a422.ttf";